function getFocusableElements(container) {
	return Array.from(
		container.querySelectorAll(
			"summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
		)
	);
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
	summary.setAttribute("role", "button");
	summary.setAttribute("aria-expanded", "false");

	if (summary.nextElementSibling.getAttribute("id")) {
		summary.setAttribute("aria-controls", summary.nextElementSibling.id);
	}

	summary.addEventListener("click", (event) => {
		event.currentTarget.setAttribute(
			"aria-expanded",
			!event.currentTarget.closest("details").hasAttribute("open")
		);
	});

	if (summary.closest("header-drawer")) return;
	summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
	var elements = getFocusableElements(container);
	var first = elements[0];
	var last = elements[elements.length - 1];

	removeTrapFocus();

	trapFocusHandlers.focusin = (event) => {
		if (
			event.target !== container &&
			event.target !== last &&
			event.target !== first
		)
			return;

		document.addEventListener("keydown", trapFocusHandlers.keydown);
	};

	trapFocusHandlers.focusout = function () {
		document.removeEventListener("keydown", trapFocusHandlers.keydown);
	};

	trapFocusHandlers.keydown = function (event) {
		if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
		// On the last focusable element and tab forward, focus the first element.
		if (event.target === last && !event.shiftKey) {
			event.preventDefault();
			first.focus();
		}

		//  On the first focusable element and tab backward, focus the last element.
		if (
			(event.target === container || event.target === first) &&
			event.shiftKey
		) {
			event.preventDefault();
			last.focus();
		}
	};

	document.addEventListener("focusout", trapFocusHandlers.focusout);
	document.addEventListener("focusin", trapFocusHandlers.focusin);

	elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
	document.querySelector(":focus-visible");
} catch {
	focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
	const navKeys = [
		"ARROWUP",
		"ARROWDOWN",
		"ARROWLEFT",
		"ARROWRIGHT",
		"TAB",
		"ENTER",
		"SPACE",
		"ESCAPE",
		"HOME",
		"END",
		"PAGEUP",
		"PAGEDOWN",
	];
	let currentFocusedElement = null;
	let mouseClick = null;

	window.addEventListener("keydown", (event) => {
		if (navKeys.includes(event.code.toUpperCase())) {
			mouseClick = false;
		}
	});

	window.addEventListener("mousedown", (event) => {
		mouseClick = true;
	});

	window.addEventListener(
		"focus",
		() => {
			if (currentFocusedElement)
				currentFocusedElement.classList.remove("focused");

			if (mouseClick) return;

			currentFocusedElement = document.activeElement;
			currentFocusedElement.classList.add("focused");
		},
		true
	);
}

function pauseAllMedia() {
	document.querySelectorAll(".js-youtube").forEach((video) => {
		video.contentWindow.postMessage(
			'{"event":"command","func":"' + "pauseVideo" + '","args":""}',
			"*"
		);
	});
	document.querySelectorAll(".js-vimeo").forEach((video) => {
		video.contentWindow.postMessage('{"method":"pause"}', "*");
	});
	document.querySelectorAll("video").forEach((video) => video.pause());
	document.querySelectorAll("product-model").forEach((model) => {
		if (model.modelViewerUI) model.modelViewerUI.pause();
	});
}

function removeTrapFocus(elementToFocus = null) {
	document.removeEventListener("focusin", trapFocusHandlers.focusin);
	document.removeEventListener("focusout", trapFocusHandlers.focusout);
	document.removeEventListener("keydown", trapFocusHandlers.keydown);

	if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
	if (event.code.toUpperCase() !== "ESCAPE") return;

	const openDetailsElement = event.target.closest("details[open]");
	if (!openDetailsElement) return;

	const summaryElement = openDetailsElement.querySelector("summary");
	openDetailsElement.removeAttribute("open");
	summaryElement.setAttribute("aria-expanded", false);
	summaryElement.focus();
}

class QuantityInput extends HTMLElement {
	constructor() {
		super();
		this.input = this.querySelector("input");
		this.changeEvent = new Event("change", { bubbles: true });

		this.querySelectorAll("button").forEach((button) =>
			button.addEventListener("click", this.onButtonClick.bind(this))
		);
	}

	onButtonClick(event) {
		event.preventDefault();
		const previousValue = this.input.value;

		event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
		if (previousValue !== this.input.value)
			this.input.dispatchEvent(this.changeEvent);
	}
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
	let t;
	return (...args) => {
		clearTimeout(t);
		t = setTimeout(() => fn.apply(this, args), wait);
	};
}

function fetchConfig(type = "json") {
	return {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
			Accept: `application/${type}`,
		},
	};
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
	window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
	return function () {
		return fn.apply(scope, arguments);
	};
};

Shopify.setSelectorByValue = function (selector, value) {
	for (var i = 0, count = selector.options.length; i < count; i++) {
		var option = selector.options[i];
		if (value == option.value || value == option.innerHTML) {
			selector.selectedIndex = i;
			return i;
		}
	}
};

Shopify.addListener = function (target, eventName, callback) {
	target.addEventListener
		? target.addEventListener(eventName, callback, false)
		: target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
	options = options || {};
	var method = options["method"] || "post";
	var params = options["parameters"] || {};

	var form = document.createElement("form");
	form.setAttribute("method", method);
	form.setAttribute("action", path);

	for (var key in params) {
		var hiddenField = document.createElement("input");
		hiddenField.setAttribute("type", "hidden");
		hiddenField.setAttribute("name", key);
		hiddenField.setAttribute("value", params[key]);
		form.appendChild(hiddenField);
	}
	document.body.appendChild(form);
	form.submit();
	document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
	country_domid,
	province_domid,
	options
) {
	this.countryEl = document.getElementById(country_domid);
	this.provinceEl = document.getElementById(province_domid);
	this.provinceContainer = document.getElementById(
		options["hideElement"] || province_domid
	);

	Shopify.addListener(
		this.countryEl,
		"change",
		Shopify.bind(this.countryHandler, this)
	);

	this.initCountry();
	this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
	initCountry: function () {
		var value = this.countryEl.getAttribute("data-default");
		Shopify.setSelectorByValue(this.countryEl, value);
		this.countryHandler();
	},

	initProvince: function () {
		var value = this.provinceEl.getAttribute("data-default");
		if (value && this.provinceEl.options.length > 0) {
			Shopify.setSelectorByValue(this.provinceEl, value);
		}
	},

	countryHandler: function (e) {
		var opt = this.countryEl.options[this.countryEl.selectedIndex];
		var raw = opt.getAttribute("data-provinces");
		var provinces = JSON.parse(raw);

		this.clearOptions(this.provinceEl);
		if (provinces && provinces.length == 0) {
			this.provinceContainer.style.display = "none";
		} else {
			for (var i = 0; i < provinces.length; i++) {
				var opt = document.createElement("option");
				opt.value = provinces[i][0];
				opt.innerHTML = provinces[i][1];
				this.provinceEl.appendChild(opt);
			}

			this.provinceContainer.style.display = "";
		}
	},

	clearOptions: function (selector) {
		while (selector.firstChild) {
			selector.removeChild(selector.firstChild);
		}
	},

	setOptions: function (selector, values) {
		for (var i = 0, count = values.length; i < values.length; i++) {
			var opt = document.createElement("option");
			opt.value = values[i];
			opt.innerHTML = values[i];
			selector.appendChild(opt);
		}
	},
};

class MenuDrawer extends HTMLElement {
	constructor() {
		super();

		this.mainDetailsToggle = this.querySelector("details");

		if (navigator.platform === "iPhone")
			document.documentElement.style.setProperty(
				"--viewport-height",
				`${window.innerHeight}px`
			);

		this.addEventListener("keyup", this.onKeyUp.bind(this));
		this.addEventListener("focusout", this.onFocusOut.bind(this));
		this.bindEvents();
	}

	bindEvents() {
		this.querySelectorAll("summary").forEach((summary) =>
			summary.addEventListener("click", this.onSummaryClick.bind(this))
		);
		this.querySelectorAll("button").forEach((button) =>
			button.addEventListener("click", this.onCloseButtonClick.bind(this))
		);
	}

	onKeyUp(event) {
		if (event.code.toUpperCase() !== "ESCAPE") return;

		const openDetailsElement = event.target.closest("details[open]");
		if (!openDetailsElement) return;

		openDetailsElement === this.mainDetailsToggle
			? this.closeMenuDrawer(
					event,
					this.mainDetailsToggle.querySelector("summary")
			  )
			: this.closeSubmenu(openDetailsElement);
	}

	onSummaryClick(event) {
		const summaryElement = event.currentTarget;
		const detailsElement = summaryElement.parentNode;
		const isOpen = detailsElement.hasAttribute("open");
		const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

		function addTrapFocus() {
			trapFocus(
				summaryElement.nextElementSibling,
				detailsElement.querySelector("button")
			);
			summaryElement.nextElementSibling.removeEventListener(
				"transitionend",
				addTrapFocus
			);
		}

		if (detailsElement === this.mainDetailsToggle) {
			if (isOpen) event.preventDefault();
			isOpen
				? this.closeMenuDrawer(event, summaryElement)
				: this.openMenuDrawer(summaryElement);
		} else {
			setTimeout(() => {
				detailsElement.classList.add("menu-opening");
				summaryElement.setAttribute("aria-expanded", true);
				!reducedMotion || reducedMotion.matches
					? addTrapFocus()
					: summaryElement.nextElementSibling.addEventListener(
							"transitionend",
							addTrapFocus
					  );
			}, 100);
		}
	}

	openMenuDrawer(summaryElement) {
		setTimeout(() => {
			this.mainDetailsToggle.classList.add("menu-opening");
		});
		summaryElement.setAttribute("aria-expanded", true);
		trapFocus(this.mainDetailsToggle, summaryElement);
		document.body.classList.add(`overflow-hidden`);
		document.documentElement.classList.add(`overflow-hidden`);
	}

	closeMenuDrawer(event, elementToFocus = false) {
		if (event !== undefined) {
			this.mainDetailsToggle.classList.remove("menu-opening");
			this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
				details.removeAttribute("open");
				details.classList.remove("menu-opening");
			});
			document.documentElement.classList.remove(
				`overflow-hidden`
			);
			document.body.classList.remove(
				`overflow-hidden`
			);
			removeTrapFocus(elementToFocus);
			this.closeAnimation(this.mainDetailsToggle);
		}
	}

	onFocusOut(event) {
		setTimeout(() => {
			if (
				this.mainDetailsToggle.hasAttribute("open") &&
				!this.mainDetailsToggle.contains(document.activeElement)
			)
				this.closeMenuDrawer();
		});
	}

	onCloseButtonClick(event) {
		const detailsElement = event.currentTarget.closest("details");
		this.closeSubmenu(detailsElement);
	}

	closeSubmenu(detailsElement) {
		detailsElement.classList.remove("menu-opening");
		detailsElement
			.querySelector("summary")
			.setAttribute("aria-expanded", false);
		removeTrapFocus();
		this.closeAnimation(detailsElement);
	}

	closeAnimation(detailsElement) {
		let animationStart;

		const handleAnimation = (time) => {
			if (animationStart === undefined) {
				animationStart = time;
			}

			const elapsedTime = time - animationStart;

			if (elapsedTime < 400) {
				window.requestAnimationFrame(handleAnimation);
			} else {
				detailsElement.removeAttribute("open");
				if (detailsElement.closest("details[open]")) {
					trapFocus(
						detailsElement.closest("details[open]"),
						detailsElement.querySelector("summary")
					);
				}
			}
		};

		window.requestAnimationFrame(handleAnimation);
	}
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
	constructor() {
		super();
	}

	openMenuDrawer(summaryElement) {
		this.header =
			this.header || document.getElementById("shopify-section-header");
		this.borderOffset =
			this.borderOffset ||
			this.closest(".header-wrapper").classList.contains(
				"header-wrapper--border-bottom"
			)
				? 1
				: 0;
		document.documentElement.style.setProperty(
			"--header-bottom-position",
			`${parseInt(
				this.header.getBoundingClientRect().bottom - this.borderOffset
			)}px`
		);

		setTimeout(() => {
			this.mainDetailsToggle.classList.add("menu-opening");
		});

		summaryElement.setAttribute("aria-expanded", true);
		trapFocus(this.mainDetailsToggle, summaryElement);
		document.body.classList.add(`overflow-hidden`);
		document.documentElement.classList.add(`overflow-hidden`);
	}
}

customElements.define("header-drawer", HeaderDrawer);

class StickyHeader extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		this.header = document.getElementById("shopify-section-header");
		this.headerBounds = {};
		this.currentScrollTop = 0;
		this.preventReveal = false;
		this.predictiveSearch = this.querySelector("predictive-search");

		this.onScrollHandler = this.onScroll.bind(this);
		this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

		this.addEventListener("preventHeaderReveal", this.hideHeaderOnScrollUp);
		window.addEventListener("scroll", this.onScrollHandler, false);

		this.createObserver();
	}

	disconnectedCallback() {
		this.removeEventListener("preventHeaderReveal", this.hideHeaderOnScrollUp);
		window.removeEventListener("scroll", this.onScrollHandler);
	}

	createObserver() {
		let observer = new IntersectionObserver((entries, observer) => {
			this.headerBounds = entries[0].intersectionRect;
			observer.disconnect();
		});

		observer.observe(this.header);
	}

	onScroll() {
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

		if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

		if (
			scrollTop > this.currentScrollTop &&
			scrollTop > this.headerBounds.bottom
		) {
			requestAnimationFrame(this.hide.bind(this));
		} else if (
			scrollTop < this.currentScrollTop &&
			scrollTop > this.headerBounds.bottom
		) {
			if (!this.preventReveal) {
				requestAnimationFrame(this.reveal.bind(this));
			} else {
				window.clearTimeout(this.isScrolling);

				this.isScrolling = setTimeout(() => {
					this.preventReveal = false;
				}, 66);

				requestAnimationFrame(this.hide.bind(this));
			}
		} else if (scrollTop <= this.headerBounds.top) {
			requestAnimationFrame(this.reset.bind(this));
		}

		this.currentScrollTop = scrollTop;
	}

	hide() {
		this.header.classList.add(
			"shopify-section-header-hidden",
			"shopify-section-header-sticky"
		);
		this.closeMenuDisclosure();
		this.closeSearchModal();
	}

	reveal() {
		this.header.classList.add("shopify-section-header-sticky", "animate");
		this.header.classList.remove("shopify-section-header-hidden");
	}

	reset() {
		this.header.classList.remove(
			"shopify-section-header-hidden",
			"shopify-section-header-sticky",
			"animate"
		);
	}

	closeMenuDisclosure() {
		this.disclosures =
			this.disclosures || this.header.querySelectorAll("details-disclosure");
		this.disclosures.forEach((disclosure) => disclosure.close());
	}

	closeSearchModal() {
		this.searchModal =
			this.searchModal || this.header.querySelector("details-modal");
		this.searchModal.close(false);
	}
}

customElements.define("sticky-header", StickyHeader);

class ModalDialog extends HTMLElement {
	constructor() {
		super();
		this.querySelector('[id^="ModalClose-"]').addEventListener(
			"click",
			this.hide.bind(this)
		);
		this.addEventListener("keyup", (event) => {
			if (event.code.toUpperCase() === "ESCAPE") this.hide();
		});
		if (this.classList.contains("media-modal")) {
			this.addEventListener("pointerup", (event) => {
				if (
					event.pointerType === "mouse" &&
					!event.target.closest("deferred-media, product-model")
				)
					this.hide();
			});
		} else {
			this.addEventListener("click", (event) => {
				if (event.target.nodeName === "MODAL-DIALOG") this.hide();
			});
		}
	}

	show(opener) {
		this.openedBy = opener;
		const popup = this.querySelector(".template-popup");
		document.body.classList.add("overflow-hidden");
		this.setAttribute("open", "");
		if (popup) popup.loadContent();
		trapFocus(this, this.querySelector('[role="dialog"]'));
		window.pauseAllMedia();
	}

	hide() {
		document.body.classList.remove("overflow-hidden");
		this.removeAttribute("open");
		removeTrapFocus(this.openedBy);
		window.pauseAllMedia();
	}
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
	constructor() {
		super();

		const button = this.querySelector("button");

		if (!button) return;
		button.addEventListener("click", () => {
			const isQuizModal = this.classList.contains('quizmodal')
			if (isQuizModal) {
				let activeStep = document.querySelector(".question-box.active").dataset.stepcount;
				if (activeStep) {
					let modalId = document.querySelector("#PopupModal-" + activeStep);
					if (modalId) modalId.show(button);
				}
			} else {
				const modal = document.querySelector(this.getAttribute("data-modal"));
				if (modal) modal.show(button);
			}

		});
	}
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
	constructor() {
		super();
		const poster = this.querySelector('[id^="Deferred-Poster-"]');
		if (!poster) return;
		poster.addEventListener("click", this.loadContent.bind(this));
	}

	loadContent() {
		window.pauseAllMedia();
		if (!this.getAttribute("loaded")) {
			const content = document.createElement("div");
			content.appendChild(
				this.querySelector("template").content.firstElementChild.cloneNode(true)
			);

			this.setAttribute("loaded", true);
			this.appendChild(
				content.querySelector("video, model-viewer, iframe")
			).focus();
		}
	}
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
	constructor() {
		super();
		this.slider = this.querySelector("ul");
		this.sliderItems = this.querySelectorAll("li");
		this.pageCount = this.querySelector(".slider-counter--current");
		this.pageTotal = this.querySelector(".slider-counter--total");
		this.prevButton = this.querySelector('button[name="previous"]');
		this.nextButton = this.querySelector('button[name="next"]');

		if (!this.slider || !this.nextButton) return;

		const resizeObserver = new ResizeObserver((entries) => this.initPages());
		resizeObserver.observe(this.slider);

		this.slider.addEventListener("scroll", this.update.bind(this));
		this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
		this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
	}

	initPages() {
		const sliderItemsToShow = Array.from(this.sliderItems).filter(
			(element) => element.clientWidth > 0
		);
		this.sliderLastItem = sliderItemsToShow[sliderItemsToShow.length - 1];
		if (sliderItemsToShow.length === 0) return;
		this.slidesPerPage = Math.floor(
			this.slider.clientWidth / sliderItemsToShow[0].clientWidth
		);
		this.totalPages = sliderItemsToShow.length - this.slidesPerPage + 1;
		this.update();
	}

	update() {
		if (!this.pageCount || !this.pageTotal) return;
		this.currentPage =
			Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

		if (this.currentPage === 1) {
			this.prevButton.setAttribute("disabled", "disabled");
		} else {
			this.prevButton.removeAttribute("disabled");
		}

		if (this.currentPage === this.totalPages) {
			this.nextButton.setAttribute("disabled", "disabled");
		} else {
			this.nextButton.removeAttribute("disabled");
		}

		this.pageCount.textContent = this.currentPage;
		this.pageTotal.textContent = this.totalPages;
	}

	onButtonClick(event) {
		event.preventDefault();
		const slideScrollPosition =
			event.currentTarget.name === "next"
				? this.slider.scrollLeft + this.sliderLastItem.clientWidth
				: this.slider.scrollLeft - this.sliderLastItem.clientWidth;
		this.slider.scrollTo({
			left: slideScrollPosition,
		});
	}
}

customElements.define("slider-component", SliderComponent);

class VariantSelects extends HTMLElement {
	constructor() {
		super();
		this.addEventListener("change", this.onVariantChange);
		this.options = []
		this.updateOptions();
		this.updateMasterId();
		let isDiscountapplied;
		document.addEventListener('subscriptionChange', () => {
			let selling_plan = document.querySelector('product-form input[name="selling_plan"]');
			const selectedVariant = this.currentVariant;
			if (!selectedVariant) {
				return;
			}
			// let buttonPrice = document.querySelector(".button_sale_price");
			// let button_compare_price = document.querySelector(".button_compare_price")
			// if (selling_plan && selectedVariant.selling_plan_allocations.length > 0) {
			// 	let currentSelectedPlan = selling_plan.value;
			// 	if (currentSelectedPlan === '') {
			// 		currentSelectedPlan = selectedVariant.selling_plan_allocations[0]['selling_plan_id']
			// 		buttonPrice.innerHTML = theme.Currency.formatMoney(selectedVariant.price, theme.settings.moneyFormat)
			// 	}
			// 	let destination = document.getElementById(`price-${this.dataset.section}`);
			// 	const filtered = selectedVariant.selling_plan_allocations.filter(entry => entry.selling_plan_id == currentSelectedPlan);
			// 	let main_sale_price = (selling_plan.value !== '') ? filtered[0].price : selectedVariant.price;
			// 	destination.querySelector('.price-item.price-item--sale').innerHTML = theme.Currency.formatMoney(main_sale_price, theme.settings.moneyFormat)
			// 	let subscriptionBox = document.querySelectorAll('.js-subscription-options');
			// 	if (buttonPrice && selling_plan.value !== '') {
			// 		buttonPrice.innerHTML = theme.Currency.formatMoney(filtered[0].price, theme.settings.moneyFormat)
			// 	}
			// 	let compare_price = filtered[0].compare_at_price;
			// 	if (subscriptionBox.length > 0) {
			// 		subscriptionBox.forEach(function (single) {
			// 			single.querySelector('.sp-product-card__price-sale').innerHTML = (single.classList.contains('js-one-time')) ? theme.Currency.formatMoney(selectedVariant.price, theme.settings.moneyFormat) : theme.Currency.formatMoney(filtered[0].price, theme.settings.moneyFormat);
			// 			if (single.querySelector('.sp-product-card__price-original')) {
			// 				single.querySelector('.sp-product-card__price-original').innerHTML = theme.Currency.formatMoney(filtered[0].compare_at_price, theme.settings.moneyFormat)
			// 			}
			// 		});
			// 	} else {
			// 		if (buttonPrice) {
			// 			buttonPrice.innerHTML = main_sale_price
			// 		}
			// 		compare_price = selectedVariant.compare_at_price
			// 	}
				// if (button_compare_price && filtered[0].compare_at_price > filtered[0].price) {
				// 	button_compare_price.innerHTML = theme.Currency.formatMoney(compare_price, theme.settings.moneyFormat);
				// 	selling_plan.value !== '' ? button_compare_price.classList.remove('hidden') : button_compare_price.classList.add('hidden');
				// }
			// } else {
			// 	buttonPrice.innerHTML = theme.Currency.formatMoney(selectedVariant.price, theme.settings.moneyFormat)
			// }
			applyDiscountCodePDP();
		})
	}

	onVariantChange() {
		this.updateOptions();
		this.updateMasterId();
		this.toggleAddButton(true, '', false);
		this.updatePickupAvailability();
		this.removeErrorMessage();
		this.updateVariantStatuses();
		if (!this.currentVariant) {
			this.toggleAddButton(true, "", true);
			this.setUnavailable();
		} else {
			this.toggleAddButton(true, "", false);
			this.updateMedia();
			this.updateURL();
			this.updateVariantInput();
			this.renderProductInfo();
			this.updateShareUrl();
		}
	}

	updateOptions() {
		this.options = Array.from(
			this.querySelectorAll("select"),
			(select) => select.value
		);
	}

	updateMasterId() {
		this.currentVariant = this.getVariantData().find((variant) => {
			//   return variant.title === this.querySelector('select').value;
			return !variant.options
				.map((option, index) => {
					return this.options[index] === option;
				})
				.includes(false);
		});
		// if (!this.currentVariant) {
		// 	this.currentVariant = this.getVariantData()[0]
		// }
		if (this.currentVariant) {
			document.querySelector(".prodsku").innerHTML = this.currentVariant.sku
		}
	}

	updateMedia() {
		if (!this.currentVariant) return;
		if (!this.currentVariant.featured_media) return;
		const newMedia = document.querySelector(
			`[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
		);

		if (!newMedia) return;
		const modalContent = document.querySelector(
			`#ProductModal-${this.dataset.section} .product-media-modal__content`
		);
		const newMediaModal = modalContent.querySelector(
			`[data-media-id="${this.currentVariant.featured_media.id}"]`
		);
		const parent = newMedia.parentElement;
		if (parent.firstChild == newMedia) return;
		modalContent.prepend(newMediaModal);
		parent.prepend(newMedia);
		this.stickyHeader =
			this.stickyHeader || document.querySelector("sticky-header");
		if (this.stickyHeader) {
			this.stickyHeader.dispatchEvent(new Event("preventHeaderReveal"));
		}
		window.setTimeout(() => {
			parent.scrollLeft = 0;
			parent
				.querySelector("li.product__media-item")
				.scrollIntoView({ behavior: "smooth" });
		});
	}

	updateURL() {
    let url = window.location.href;
    
    // Create a URL object from the current URL
    let urlObj = new URL(url);
    
    // Update the parameter value
    urlObj.searchParams.set('variant', this.currentVariant.id);
		if (!this.currentVariant || this.dataset.updateUrl === "false") return;
		window.history.replaceState(
			{},
			"",
			`${urlObj.toString()}`
		);
	}

	updateShareUrl() {
		const shareButton = document.getElementById(
			`Share-${this.dataset.section}`
		);
		if (!shareButton) return;
		shareButton.updateUrl(
			`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
		);
	}

	updateVariantInput() {
		const productForms = document.querySelectorAll(
			`#product-form-${this.dataset.section}, #product-form-installment`
		);
		productForms.forEach((productForm) => {
			const input = productForm.querySelector('input[name="id"]');
			input.value = this.currentVariant.id;
			input.dispatchEvent(new Event("change", { bubbles: true }));
		});
	}

	updateVariantStatuses() {
		const selectedOptionOneVariants = this.variantData.filter(
			(variant) => this.querySelector(':checked').value === variant.option1
		);
		const inputWrappers = [...this.querySelectorAll('.product-form__input')];
		inputWrappers.forEach((option, index) => {
			if (index === 0) return;
			const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
			const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
			const availableOptionInputsValue = selectedOptionOneVariants
				.filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
				.map((variantOption) => variantOption[`option${index + 1}`]);
			this.setInputAvailability(optionInputs, availableOptionInputsValue);
		});
	}

	setInputAvailability(listOfOptions, listOfAvailableOptions) {
		listOfOptions.forEach((input) => {
			if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
				input.innerText = input.getAttribute('value');
			} else {
				input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
			}
		});
	}

	updatePickupAvailability() {
		const pickUpAvailability = document.querySelector("pickup-availability");
		if (!pickUpAvailability) return;

		if (this.currentVariant && this.currentVariant.available) {
			pickUpAvailability.fetchAvailability(this.currentVariant.id);
		} else {
			pickUpAvailability.removeAttribute("available");
			pickUpAvailability.innerHTML = "";
		}
	}

	removeErrorMessage() {
		const section = this.closest("section");
		if (!section) return;

		const productForm = section.querySelector("product-form");
		// if (productForm) productForm.handleErrorMessage();
	}

	renderProductInfo() {
    let url = window.location.href;
		let product_info = document.getElementById(`ProductInfo-${this.dataset.section}`);
		if (product_info) {
			product_info.style.pointerEvents = 'none'
		}
    // Create a URL object from the current URL
    let urlObj = new URL(url);
    
    // Update the parameter value
    urlObj.searchParams.set('variant', this.currentVariant.id);
		fetch(
			`${urlObj.toString()}&section_id=${this.dataset.section}&snippet=snippet1`
		)
			.then((response) => response.text())
			.then((responseText) => {
				const id = `price-${this.dataset.section}`;
				const html = new DOMParser().parseFromString(responseText, "text/html");
				const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
					const source = html.getElementById(`${id}-${this.dataset.section}`);
					const destination = document.querySelector(`#${id}-${this.dataset.section}`);
					if (source && destination) {
						destination.innerHTML = source.innerHTML;
						destination.classList.toggle('hidden', shouldHide(source));
					}
				};

				updateSourceFromDestination('price');
				// updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
				updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
				updateSourceFromDestination('variant');
				// updateSourceFromDestination('Price-Per-Item', ({ classList }) => classList.contains('hidden'));
				// observeRecharge();

				document.dispatchEvent(new Event("subscriptionChange", { bubbles: true }))
				if (this.currentVariant) {
					this.toggleAddButton(
						!this.currentVariant.available,
						window.variantStrings.soldOut
					);
				}
				if (product_info) {
					product_info.style.pointerEvents = ''
				}
			});
	}

	toggleAddButton(disable = true, text, modifyClass = true) {
		const productForm = document.getElementById(
			`product-form-${this.dataset.section}`
		);
		if (!productForm) return;
		const addButton = productForm.querySelector('[name="add"]');
		const addButtonText = productForm.querySelector('[name="add"] > span');
		const newATCBtn = productForm.querySelector(".new-atc__button");
		const newAddButton = productForm.querySelector(".button_text");

		if (!addButton) return;
		if (disable) {
			newATCBtn.setAttribute("disabled", "disabled");
			addButton.setAttribute("disabled", "disabled");
			if (text) {
				addButtonText.textContent = text;
				newAddButton.textContent = text;
			}
		} else {
			newATCBtn.classList.remove('hidden')
			newATCBtn.removeAttribute("disabled");
			addButton.removeAttribute("disabled");
			addButtonText.textContent = window.variantStrings.addToCart;
			newAddButton.textContent = window.variantStrings.addToCart;
		}

		if (!modifyClass) return;
	}

	setUnavailable() {
		const button = document.getElementById(
			`product-form-${this.dataset.section}`
		);
		const newATCBtn = button.querySelector(".new-atc__button");
		const newAddButton = newATCBtn.querySelector(".button_text");
		const addButton = button.querySelector('[name="add"]');
		const addButtonText = button.querySelector('[name="add"] > span');
		const price = document.getElementById(`price-${this.dataset.section}`);
		if (!addButton) return;
		addButtonText.textContent = window.variantStrings.unavailable;
		newAddButton.textContent = window.variantStrings.unavailable;
		//if (price) price.classList.add("visibility-hidden");
	}

	getVariantData() {
		this.variantData =
			this.variantData ||
			JSON.parse(this.querySelector('[type="application/json"]').textContent);
		return this.variantData;
	}
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
	constructor() {
		super();
	}

	setInputAvailability(listOfOptions, listOfAvailableOptions) {
		listOfOptions.forEach((input) => {
			if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
				input.classList.remove('disabled');
				input.disabled = false; 
			} else {
				input.classList.add('disabled');
				input.disabled = true; 
			}
		});
	}

	updateOptions() {
		const fieldsets = Array.from(this.querySelectorAll("fieldset"));
		this.options = fieldsets.map((fieldset) => {
			return Array.from(fieldset.querySelectorAll("input")).find(
				(radio) => radio.checked
			).value;
		});
	}
}

customElements.define("variant-radios", VariantRadios);

window.theme = window.theme || {};
theme.Currency = function () {
	var moneyFormat = "${{amount}}"
		, superScript = theme && theme.settings && theme.settings.superScriptPrice;
	function defaultTo(value, defaultValue) {
		return value == null || value !== value ? defaultValue : value
	}
	function formatMoney(cents, format) {
		format || (format = theme.settings.moneyFormat),
			typeof cents == "string" && (cents = cents.replace(".", ""));
		var value = ""
			, placeholderRegex = /\{\{\s*(\w+)\s*\}\}/
			, formatString = format || moneyFormat;
		function formatWithDelimiters(number, precision, thousands, decimal) {
			if (precision = defaultTo(precision, 2),
				thousands = defaultTo(thousands, ","),
				decimal = defaultTo(decimal, "."),
				isNaN(number) || number == null)
				return 0;
			number = (number / 100).toFixed(precision);
			var parts = number.split(".")
				, dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands)
				, centsAmount = parts[1] ? decimal + parts[1] : "";
			return dollarsAmount + centsAmount
		}
		switch (formatString.match(placeholderRegex)[1]) {
			case "amount":
				value = formatWithDelimiters(cents, 2),
					superScript && value && value.includes(".") && (value = value.replace(".", "<sup>") + "</sup>");
				break;
			case "amount_no_decimals":
				value = formatWithDelimiters(cents, 0);
				break;
			case "amount_with_comma_separator":
				value = formatWithDelimiters(cents, 2, ".", ","),
					superScript && value && value.includes(",") && (value = value.replace(",", "<sup>") + "</sup>");
				break;
			case "amount_no_decimals_with_comma_separator":
				value = formatWithDelimiters(cents, 0, ".", ",");
				break;
			case "amount_no_decimals_with_space_separator":
				value = formatWithDelimiters(cents, 0, " ");
				break
		}
		return formatString.replace(placeholderRegex, value)
	}
	function getBaseUnit(variant) {
		if (variant && !(!variant.unit_price_measurement || !variant.unit_price_measurement.reference_value))
			return variant.unit_price_measurement.reference_value === 1 ? variant.unit_price_measurement.reference_unit : variant.unit_price_measurement.reference_value + variant.unit_price_measurement.reference_unit
	}
	return {
		defaultTo,
		formatMoney,
		getBaseUnit
	}
}()

function preventHyperLinking() {
	document.querySelectorAll(".utility__prevent-parent-hyperlinking").forEach(node => {
		node.removeEventListener("click", stopHyperlink); // Remove existing listener
		node.addEventListener("click", stopHyperlink); // Add new listener
	});
}

// Separate event handler function
function stopHyperlink(event) {
	event.stopPropagation();
	event.preventDefault();
}